import { render } from "./todoEdit.vue?vue&type=template&id=94f5fd9a&scoped=true"
import script from "./todoEdit.vue?vue&type=script&lang=js"
export * from "./todoEdit.vue?vue&type=script&lang=js"

import "./todoEdit.vue?vue&type=style&index=0&id=94f5fd9a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94f5fd9a"]])

export default __exports__